<template>
  <div class="bg-container">
    <v-container fluid fill-height :style="{ maxWidth: '1200px' }">
      <v-layout flex align-center>
        <v-flex xs12 sm6 md4 offset-sm3 offset-md4>
          <v-card class="no-shadow no-background">
            <v-card-title primary-title>
              <h1 class="headline">Reset password</h1>
            </v-card-title>
            <v-card-text>
              <div v-if="status_error">
                <p style="color: red;">{{ status }}</p>
              </div>
              <v-form
                v-if="!status_success"
                @submit.prevent="reset"
                @keydown="form.onKeydown($event)"
              >
                <!-- Email -->
                <v-text-field
                  v-model="form.email"
                  label="E-Mail"
                  placeholder="E-Mail"
                  single-line
                  required
                  autofocus
                  :error="form.errors.has('email')"
                  class="placeholer-color"
                ></v-text-field>
                <has-error :form="form" field="email"></has-error>

                <v-text-field
                  v-model="form.password"
                  label="Password"
                  :type="type"
                  placeholder="Password"
                  single-line
                  required
                  :error="form.errors.has('password')"
                  class="placeholer-color"
                  ><template v-slot:append>
                    <img
                      width="24"
                      height="24"
                      :src="password_icon"
                      @click="togglePassword"
                    />
                  </template>
                </v-text-field>
                <has-error :form="form" field="password"></has-error>

                <!-- Password confirmation -->
                <v-text-field
                  v-model="form.password_confirmation"
                  label="Password confirmation"
                  :type="type"
                  placeholder="Password confirmation"
                  single-line
                  required
                  :error="form.errors.has('password_confirmation')"
                  class="placeholer-color"
                  ><template v-slot:append>
                    <img
                      width="24"
                      height="24"
                      :src="password_icon"
                      @click="togglePassword"
                    />
                  </template>
                </v-text-field>
                <has-error
                  :form="form"
                  field="password_confirmation"
                ></has-error>

                <v-layout>
                  <v-flex class="text-xs-left">
                    <v-btn
                      type="submit"
                      :loading="form.busy"
                      color="primary"
                      right
                      >Reset</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Form from "vform";
import axios from "axios";

export default {
  metaInfo() {
    return { title: this.$t("reset_password") };
  },

  data: () => ({
    status: "",
    status_error: false,
    status_success: false,
    password_icon: "/img/eye-icon.svg",
    type: "password",
    form: new Form({
      token: "",
      email: "",
      password: "",
      password_confirmation: ""
    })
  }),
  methods: {
    async reset() {
      this.form.token = this.$route.params.token;

      const { data } = await this.form.post("/api/v1/password/reset");

      this.status = data.status;
      if (this.status.includes("Your password has been reset!")) {
        this.status_success = true;
        this.status_error = false;
        this.form.reset();
        await this.$router.push({
          path: "/login",
          query: { status: "reset-success" }
        });
      } else {
        this.status_error = true;
        this.status_success = false;
      }
    },
    togglePassword() {
      this.type = this.type === "password" ? "text" : "password";
      this.password_icon =
        this.type === "password"
          ? "/img/eye-icon.svg"
          : "/img/eye-open-icon.svg";
    }
  }
};
</script>

<style scoped>
.bg-container {
  background: url("/img/background-center.png") center top no-repeat,
  url("/img/background-full.jpg") repeat;
  height: 100%;
}
.no-shadow {
  box-shadow: none !important;
}
.no-background {
  background: transparent;
}
.placeholer-color >>> input::placeholder {
  color: #b8d2ff !important;
  opacity: 1;
}
>>> .v-input__slot::before {
  border-color: #b8d2ff !important;
}

>>> .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  width: 196px;
  height: 44px;
  margin-top: 32px;
  box-shadow: none !important;
}
.headline {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 40px !important;
  line-height: 48px !important;
  letter-spacing: 0.02em !important;
  background: -webkit-linear-gradient(#468aff, #0051dd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.head-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #103a84;
  margin-bottom: 0px;
}

.v-form .p {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #103a84;
}
.v-messages__message {
  color: #ed4242;
}
.invalid-feedback {
  color: #ed4242;
}
@media (max-width: 1440px) {
  .bg-container {
    background: url("/img/background-center.png") center top no-repeat,
    url("/img/background-full-1440.jpg") repeat;
    height: 100%;
  }
}
@media (max-width: 768px) {
  .bg-container {
    background: #ffffff url("/img/bg-tablet-left.jpg") left top no-repeat;
    height: 100%;
  }
}
@media (max-width: 600px) {
  .bg-container {
    background: #ffffff;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/auth/password/reset.vue